import { render, staticRenderFns } from "./inviteNew.vue?vue&type=template&id=07a54f01&scoped=true"
import script from "./inviteNew.vue?vue&type=script&lang=js"
export * from "./inviteNew.vue?vue&type=script&lang=js"
import style0 from "./inviteNew.vue?vue&type=style&index=0&id=07a54f01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a54f01",
  null
  
)

export default component.exports